import {LoyaltyProgramServiceTemplate} from "../../templates/LoyaltyProgramTemplate/LoyaltyProgramServiceTemplate";

const LoyaltyProgramServicePage = () => {
  return <LoyaltyProgramServiceTemplate />;
};

export default LoyaltyProgramServicePage;
